import React from "react";
const ContactCTA = () => <section>hey i'm ContactCTA</section>;
export default ContactCTA;
